<template lang='pug'>
  .container
    article
      h2 Honorare
      h4 Gute Arbeit kostet Geld
      p
        | Die Transparenz der Gebühren ist mir ein besonderes Anliegen.
        br
        | Die gesetzlich vorgesehene Abrechnung der Rechtsanwaltshonorare in Deutschland ist im bundeseinheitlichen <b>Rechtsanwaltsvergütungsgesetz</b> (<b>RVG</b>) geregelt. 
        | Die danach zu berechnenden Gebühren richten sich hauptsächlich nach der Höhe des Gegenstandswertes, das heißt nach dem wirtschaftlichen Interesses des Mandanten (zum Beispiel der Forderungshöhe). 
        | Sodann nach den so genannten Rahmengebühren, die im Vergütungsverzeichnis als Anlage zum RVG aufgelistet sind. Es werden die Gebühren für die verschiedenen möglichen anwaltlichen Tätigkeiten wie Beratung, vorgerichtliche Vertretung, Einreichen der Klage, Verhandlungstermin, ggbfls. 
        | Vergleich und anderes berechnet. Bei sehr einfachen Fällen mit hohen Streitwerten oder umgekehrt bei wirtschaftlich zwar unbedeutenden, aber dennoch rechtlich anspruchsvollen und besonders zeitintensiven Streitigkeiten ist das RVG als Preisgrundlage der anwaltlichen Leistungen unbefriedigend und teils unangemessen. 
        | Nach Auffassung des Gesetzgebers soll dies durch die regelmäßige Mischung von Mandaten mit unterschiedlichen Streitwerten ausgeglichen werden. Es bedeutet indessen letztlich eine Subventionierung der komplizierten, anspruchsvollen und zeitintensiven Mandate durch die einfachen Fälle mit vergleichsweise hohen Streitwerten.
        br
        | Es können hiervon abweichend oder auch zusätzlich Vereinbarungen über die Vergütung getroffen werden, die allerdings die gesetzlichen Gebühren nicht unterschreiten dürfen. 

      h4 Stundenhonorare
      p
        | Ich vereinbare für meine anwaltlichen Dienstleistungen regelmäßig konkret projektbezogene Honorare, meist nach Stunden berechnet oder lege eine angemessene Pauschalierung zu Grunde. 
        | Dabei kalkuliere ich einen Stundensatz von netto 225 Euro bis 275 Euro, je nach Bedeutung, wirtschaftlichem Wert (und Haftungsrisiko) des Mandates sowie unter Beachtung des voraussichtlichen Zeitaufwandes und der juristischen Schwierigkeit. 
        | Eine zeitnahe Abrechnung gewährleistet dabei die Transparenz und Prüfbarkeit meiner Tätigkeit sowie der entstehenden Kosten. Ich bin gesetzlich gehalten darauf hinzuweisen, dass in gerichtlichen Verfahren Vergütungsvereinbarungen nicht getroffen werden dürfen, die zu einer Unterschreitung der gesetzlichen Gebühren führen würde (§ 49b BRAO).

      h4 Pauschale Vergütungsvereinbarung – Beratungsverträge
      p
        | Vor allem für langfristige Mandatsbeziehungen mit regelmäßigem und auch häufig kurzfristigem Beratungsbedarf von beispielsweise Unternehmen empfiehlt sich der Abschluss eines Beratungsvertrages mit der Vereinbarung einer monatlichen Grundpauschale, die je nach Bedarf ein Basishonorar von mindestens 550 EUR vorsieht.
        | Die Honorare bei Vergütungsvereinbarungen rechne ich dabei monatlich ab, sodass für den Mandanten ebenfalls die Transparenz und Kostenkontrolle sichergestellt ist.
</template>

<script>
  export default {
    name: 'Honorare',
    data () {
      return {}
    }
  }
</script>

<style lang='stylus' scoped>
</style>


// WEBPACK FOOTER //
// src/components/content/Honorare.vue